import styled from 'styled-components'

export const Strong = styled.strong``
